// extracted by mini-css-extract-plugin
module.exports = {"icon":"CloseButton_icon__2b9se"};